<template>
  <div class="position-relative dinA4">
    <img :src="require('@/assets/peninsular-header.png')" class="mb-6 page__header" />
    <div class="page__container">
      <div class="d-flex mb-12">
        <img class="img-contain product-icon--reduced" :src="require('@/assets/ctt24-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">
            Tu envío llega al día siguiente
          </p>
          <p class="body-1 justify-text">
            <b>Cobertura Península Ibérica:</b> Servicio de Entrega prevista durante el siguiente
            día laborable al de su recogida (España y Portugal). <u>Preaviso de entrega</u>,
            servicio de <u>Entrega flexible</u> y <u>Predicción de franja horaria</u> GRATIS
          </p>
        </div>
      </div>

      <div class="d-flex mb-12">
        <img class="img-contain product-icon" :src="require('@/assets/ctt1330-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">
            Tu envío llega antes de las 14:00h
          </p>
          <p class="body-1 justify-text">
            <b>Cobertura Península Ibérica:</b> Servicio de Entrega prevista antes de las 14:00h
            del siguiente día laborable al de su recogida (España y Portugal).
          </p>
        </div>
      </div>

      <div class="d-flex mb-12">
        <img class="img-contain product-icon" :src="require('@/assets/ctt10-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">
            Tu envío llega antes de las 10:00h
          </p>
          <p class="body-1 justify-text">
            <b>Cobertura Península Ibérica:</b> Servicio de Entrega prevista antes de las 10:00h
            del día siguiente laborable al de su recogida (España y Portugal).
          </p>
        </div>
      </div>

      <div class="d-flex mb-12">
        <img class="img-contain product-icon" :src="require('@/assets/ctt830-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">
            Tu envío llega antes de las 8:30h
          </p>
          <p class="body-1 justify-text">
            <b>Cobertura Península Ibérica:</b> Servicio de Entrega prevista antes de las 8:30h
            de la mañana del día siguiente laborable al de la recogida.
          </p>
        </div>
      </div>

      <div class="d-flex">
        <img class="img-contain product-icon--reduced" :src="require('@/assets/ctt48-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">
            Tu envío llega en 48h
          </p>
          <p class="body-1 justify-text">
            <b>Cobertura Península Ibérica:</b> Servicio de Entrega prevista en un plazo de 48h
            (España y Portugal). <u>Preaviso de entrega</u>, servicio de <u>Entrega flexible</u> y
            <u>Predicción de franja horaria</u> GRATIS
          </p>
        </div>
      </div>
    </div>

    <Footer logo :page="previousPages + 1" />
  </div>
</template>

<script>
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2021/Footer'

export default {
  name: 'PeninsularIntro',
  components: { Footer },
  data() {
    return {
      previousPages: 0,
    }
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('PeninsularIntro')
  },
}
</script>
